import { Box, Button, Flex, Heading, Image, Input, Label, Spinner, Text, useColorMode } from "theme-ui";
// import { emailVerify } from "../../../store/actions/login.action";
// import { ForgotFormValues, RootState } from "../../../../@types";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import theme from "../../../theme";
import * as Yup from "yup";
import { useSearchParams } from "react-router-dom";
import { forgetpassword } from "../../../store/actions/login.action";
import { RootState } from "../../../../@types";
import { useSelector } from "react-redux";
import { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { bucketUrl } from "../../../utils/global";
interface ResetFormValues {
    userID?: string;
    token?: string;
    Password: string;
    confirmPassword: string;
}
const passwordRegex = /^((?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9]).{6,})\S$/;

const validationSchema = Yup.object({
    Password: Yup.string()
        .required('Please enter a new password')
        .matches(passwordRegex, "password must contain at least one uppercase letter, one lowercase letter, and one number"),
    confirmPassword: Yup.string()
        .required('Please confirm your password')
        .oneOf([Yup.ref('Password')], 'The confirmation password does not match the password')
});

const ForgotPassword = () => {
    const navigate = useNavigate()
    const loader = useSelector((state: RootState) => state.auth.loader);
    const [searchParams] = useSearchParams()
    const dispatch = useDispatch();
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [colorMode] = useColorMode();
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";

    const handleForgot = (values: ResetFormValues) => {
        // console.log("Forgot password form values:", payload);
        values["userID"] = searchParams.get("Id") || "";
        values["token"] = searchParams.get("token") || "";
        console.log(values, searchParams.get("Id"));

        dispatch(forgetpassword(values,
            (response: any) => {
                if (response) {
                    navigate("/login")
                }
            }))
    };

    const Formik = useFormik({
        initialValues: { Password: "", confirmPassword: "" },
        validationSchema: validationSchema,
        onSubmit: (values: ResetFormValues) => {
            handleForgot(values);
        },
    });

    return (
        <>
            <Flex
                sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '90vh' }}>
                <Image src={bucketUrl + "PEC_fullName_logo.png"} alt="Logo" sx={{ width: ["70%", "30%", "20%"], height: 'auto' }} />
                <Heading as='h1' className="mt-5" sx={{ color: titleHeader, lineHeight: 'heading' }}>Forgot Password</Heading>

                <Box sx={{ width: ['90%', '70%', '40%'], mt: 6, gap: "23px" }}>
                    <form onSubmit={Formik.handleSubmit}>
                        <Box mb={3}>
                            <Label htmlFor="Password" style={{ fontSize: "17px", fontWeight: '600', color: titleHeader }}>New Password</Label>
                            {/* value={Formik.values.Password} */}
                            <div className="p-div">
                                <Input type={passwordVisible ? "text" : "password"} id="Password" name="Password" className='form-control' onChange={Formik.handleChange} onBlur={Formik.handleBlur} placeholder="Enter your new password"
                                    sx={{
                                        width: '100%', p: 2, mt: 1, border: '1px solid', borderColor: Formik.touched.Password && Formik.errors.Password ? `${theme?.colors?.red}` : 'red',
                                    }} />
                                <span
                                    style={{ display: Formik.values.Password?.length > 0 ? "flex" : "none", alignItems: 'center', cursor: 'pointer', color: '#888' }}
                                    className="eye-icon"
                                    onClick={() => setPasswordVisible(!passwordVisible)}>
                                    {passwordVisible ? <FiEye size={18} /> : <FiEyeOff size={18} />}
                                </span>
                            </div>
                            {Formik.touched.Password && Formik.errors.Password && (
                                <Text color="red"> {Formik.errors.Password} </Text>
                            )}
                        </Box>
                        <Box mb={3}>
                            <Label htmlFor="confirmPassword" style={{ fontSize: "17px", fontWeight: '600', color: titleHeader }}>Confirm Password</Label>
                            {/* value={Formik.values.confirmPassword} */}
                            <div className="p-div">
                                <Input type={confirmPasswordVisible ? "text" : "password"} id="confirmPassword" name="confirmPassword" className='form-control' onChange={Formik.handleChange} onBlur={Formik.handleBlur} placeholder="Enter your confirm password"
                                    sx={{
                                        width: '100%', p: 2, mt: 1, border: '1px solid', borderColor: Formik.touched.confirmPassword && Formik.errors.confirmPassword ? `${theme?.colors?.red}` : 'red',
                                    }} />
                                <span
                                    style={{ display: Formik.values.confirmPassword?.length > 0 ? "flex" : "none", alignItems: 'center', cursor: 'pointer', color: '#888' }}
                                    className="eye-icon"
                                    onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}>
                                    {confirmPasswordVisible ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                                </span>
                            </div>
                            {Formik.touched.confirmPassword && Formik.errors.confirmPassword && (
                                <Text sx={{ color: `${theme?.colors?.red}` }}> {Formik.errors.confirmPassword} </Text>
                            )}
                        </Box>
                        <Button type="submit" sx={{ width: '100%', bg: `${theme.colors?.primary}`, color: `${theme?.colors?.white}`, py: 2, borderRadius: '4px', cursor: 'pointer' }}>
                            {loader ? (<Spinner sx={{ color: theme.colors?.background, width: 3, p: 0, m: 0 }} />) : ("Submit")}
                        </Button>
                    </form>
                    <Box mt={3}>
                        <Link to="/login" style={{ textDecoration: 'underline', color: `${theme.colors?.primary}` }}>
                            Back to Login
                        </Link>
                    </Box>
                </Box>
            </Flex>
        </>

    )
}

export default ForgotPassword